import { reactive, ref, computed } from '@vue/composition-api'
import * as apiMyLink from '@/api/my-link'

/**
 * マイリンク追加
 */
export const getGroup = (props, context) => {
  
  const group1 = reactive({

    title: '',

    url: '',

    // 別窓
    new_window: true, // 初期状態はチェック

    // エラーメッセージ
    error_title: '',
    error_url: '',

    /**
     * 初期表示
     */
    init: () => {

    },

    /**
     * 保存ボタンを押下した場合
     */
    onSaveButtonClicked: () => {

      // エラーメッセージを初期化
      group1.error_title = ''
      group1.error_url = ''

      // 入力エラーチェック処理
      let isError = false

      if (group1.title === '') {
        group1.error_title = '必須項目です'
        isError = true
      }

      if (group1.url === '' || group1.url === 'http://' || group1.url === 'https://') {
        group1.error_url = '必須項目です'
        isError = true
      }

      if (isError) {
        return
      }

      // マイリンク登録APIをコール
      const params = {}
      params.before_id = 0
      params.title = group1.title
      params.url = group1.url
      params.new_window = group1.new_window

      apiMyLink.register(params)
        .then(response => {
          if (response) {
            const { data } = response

            // 親ウィンドウのマイリンク一覧をリロード
            context.emit('loadMyLink')

            // ウィンドウを閉じる
            context.emit('closeMyLinkCreate')
          }
        })
    }
  })

  return group1
}
